import styled from 'styled-components';

import TextComponent from '../ui/Text';

export default styled(TextComponent)`
  color: ${({ theme }) => theme.COLOR_TEXT_MUTED};
  font-size: 0.875rem;
  text-align: center;
`;
